import Fit from "../Certificates/Fit";

const WithOutHeaderReportPrint = () => {
  return <Fit noHeader={true} />;
};
export default WithOutHeaderReportPrint;
